export default "__VITE_ASSET__D0mX8J_w__"